export default "https://cdn-static.gokick.com/assets/abc7ffeff8198bd9a29b582a19941a8ba3b1c5b9/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";